export enum CardStatus {
  Created = 'created',
  PendingActivation = 'pending_activation',
  Active = 'active',
  Redeemed = 'redeemed',
  Expired = 'expired',
  Cancelled = 'cancelled'
}